<template>
  <div class="absolute inset-0 flex flex-col items-center justify-center p-4">
    <AnimationDocumentError class="h-20"/>
    <div class="mx-auto mt-6 mb-40 w-full max-w-md text-center lg:mb-20">
      <p class="text-3xl font-bold text-slate-900">Hmm, something didn't work...</p>
      <p class="mt-1 font-medium text-slate-500">
        Please try again. If the problem persists, please contact us.
      </p>
      <p class="mt-1 mb-4 text-slate-500">
        <ExclamationCircleIcon class="-mt-1 mr-1 inline-block h-5 w-5 text-red-600"/>
        <b>Error Message:</b>
        <span class="ml-1 font-medium">
          {{store.resume.error || "Unknown Error"}}
        </span>
      </p>
      <FormButton @click="tryAgain" bold color="secondary" class="mt-6 block mx-auto" flex>
        <span class="block">Try Again</span>
        <ArrowUturnRightIcon class="h-4 w-4"/>
      </FormButton>
    </div>
  </div>
</template>

<script setup>
import AnimationDocumentError from "./AnimationDocumentError.vue";
import FormButton from "./FormButton.vue";
import {ArrowUturnRightIcon, ExclamationCircleIcon} from "@heroicons/vue/20/solid/index.js";
import {useParseResumeStore} from "../stores/ParseResumeStore.js";

const emits = defineEmits(["retry"]);
const store = useParseResumeStore();

const tryAgain = () => {
  emits("retry");
  store.resume.error = null;
};
</script>
